import type { ReactNode } from "react";

/** A titled block of the classic storefront template — the design's "Label" above each row. */
export function ClassicSection({
  id,
  title,
  children,
}: {
  id?: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className="flex scroll-mt-20 flex-col gap-3.5">
      <h2 className="text-3xl font-bold tracking-tight text-foreground">{title}</h2>
      {children}
    </section>
  );
}
